<template>
  <van-list
    class="order-list container-h-full"
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
    <h1 class="title">
      <i class="iconhebei iconbaoming2"></i>
      {{ title }}
    </h1>
    <template v-for="(item, idx) in list">
      <template v-if="isSignup">
        <card
          class="m-b"
          :key="idx"
          :isTicket="false"
          :act_name="item.act_name"
          :startTime="item.ctime"
          :username="item.username"
          :phone="item.phone"
        ></card>
      </template>
      <template v-else>
        <card
          class="m-b"
          :isTicket="true"
          :key="idx"
          :act_name="item.musuem_name"
          :startTime="item.visit_time"
          :username="item.username"
          :phone="item.phone"
          :idCard="item.identity"
          :status="item.status"
          :hanldeSkip="unreser_ticket"
        ></card>
      </template>
    </template>
  </van-list>
</template>

<script>
import card from "@components/ReserCard.vue";
import { List } from "vant";
// import { myApplication, booked, cancel } from "@ticketUrl";
import { getTicketUrl, getActivitytUrl } from "@url";
import axios from "axios";
const DEFAULT_TYPE = "signup";
export default {
  name: "OrderList",
  components: {
    card,
    [List.name]: List,
  },
  inject: ["reload"],
  created() {
    let { type } = this.$route.query;
    this.type = type;
  },
  data() {
    return {
      type: DEFAULT_TYPE, // signup 报名 tickets门票
      list: [],
      loading: false,
      finished: false,
      // query: {
      //   pageNumber: 0,
      //   pageSize: 5,
      // },
      page: 1,
    };
  },
  computed: {
    //是否为活动 true 活动 false 门票
    isSignup() {
      return this.type === DEFAULT_TYPE;
    },
    title() {
      return this.isSignup ? "活动预约" : "门票预约";
    },
    // 用户手机号
    userPhone() {
      return this.$store.state.userInfo.info.phone;
    },
  },
  methods: {
    unreser_ticket() {
      window.location.href =
        "https://git.gblw.net/index/museum/index.html?id=1&name=%E6%B5%B7%E5%8D%97%E7%9C%81%E5%8D%9A%E7%89%A9%E9%A6%86";
    },
    getTicketList() {
      // 首次登陆无手机号 限制发送请求
      if (this.userPhone == "") {
        this.finished = true;
        this.loading = false;
        return this.$toast("请先绑定手机号！");
      }
      axios
        .get(getTicketUrl, {
          params: { phone: this.userPhone },
        })
        .then(({ data: { data, code } }) => {
          if (code == 200) {
            this.list = data.data;
            if (data.current_page == data.last_page || data.last_page == 0) {
              this.finished = true;
            }
          }
          this.loading = false;
        });
    },
    getActivityList() {
      // 首次登陆无手机号 限制发送请求
      if (this.userPhone == "") {
        this.finished = true;
        this.loading = false;
        return this.$toast("请先绑定手机号！");
      }
      axios
        .get(getActivitytUrl, {
          params: { phone: this.userPhone },
        })
        .then(({ data: { data, code } }) => {
          if (code == 200) {
            this.list = data.data;
            if (data.current_page == data.last_page || data.last_page == 0) {
              this.finished = true;
            }
          }
          this.loading = false;
        });
    },
    onLoad() {
      this.loading = true;
      // false 为门票 true为活动
      this.isSignup ? this.getActivityList() : this.getTicketList();
    },
  },
};
</script>

<style lang='less' scoped>
.order-list {
  .title {
    height: 46px;
    line-height: 46px;
    padding: 0 20px;
    color: #606060;
    font-size: 14px;
    font-weight: 500;
    .iconhebei {
      color: #5a9bf6;
    }
  }
  .list {
    width: 700px;
    display: flex;
    justify-content: space-between;
    line-height: 46px;
    border: 1px solid #ccc;
  }
  .m-b {
    margin-bottom: 10px;
  }
}
</style>